import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

@Component({
  selector: 'bmcore-sign-up-page',
  templateUrl: './bmcore-sign-up-page.component.html',
  styleUrls: ['./bmcore-sign-up-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSignUpPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
